import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from './auth.service';
import { DlgPasswordExpirationWarningComponent } from '../commons/dlg-password-expiration-warning/dlg-password-expiration-warning.component';
import { DlgForcePasswordChangeComponent } from '../commons/dlg-force-password-change/dlg-force-password-change.component';

@Injectable({
  providedIn: 'root'
})
export class PasswordExpirationService {

  private passwordDialogOpen = false; // Evitar abrir el diálogo múltiples veces
  private hasCheckedOnInit = false; // Para verificar solo una vez al iniciar

  constructor(
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  // Método para inicializar verificación al cargar la app
  initializeCheck(): void {
    if (!this.hasCheckedOnInit && this.authService.isAuthenticated()) {
      this.checkPasswordExpiration();
      this.hasCheckedOnInit = true;
    }
  }

  checkPasswordExpiration(): void {
    // Evitar abrir múltiples diálogos
    if (this.passwordDialogOpen) {
      return;
    }

    const tokenData = this.authService.getTokenData();
    
    // Prioridad 1: Si requiere cambio de contraseña (forzado o expirada)
    if (tokenData && tokenData.requirePasswordChange) {
      this.passwordDialogOpen = true;
      const dialogRef = this.dialog.open(DlgForcePasswordChangeComponent, {
        data: {
          reason: tokenData.passwordChangeReason
        },
        disableClose: true,
        maxWidth: '600px',
        width: '90vw'
      });
      
      dialogRef.afterClosed().subscribe(() => {
        this.passwordDialogOpen = false;
      });
    }
    // Prioridad 2: Si solo hay advertencia (contraseña próxima a expirar)
    else if (tokenData && tokenData.passwordExpirationWarning) {
      this.passwordDialogOpen = true;
      const dialogRef = this.dialog.open(DlgPasswordExpirationWarningComponent, {
        data: {
          daysRemaining: tokenData.daysRemaining
        },
        disableClose: false,
        maxWidth: '500px'
      });
      
      dialogRef.afterClosed().subscribe(() => {
        this.passwordDialogOpen = false;
      });
    }
  }
}
